// import globlaConfig from '@/common/config'
import _default from './default'

let env = {}

switch (process.env.NODE_ENV) {
  case 'development':
    env = require('./development')
    break;
  case 'production':
    env = require('./production')
    break;
  // default:
  //   env = {}
}

export default Object.assign({}, _default, env.default)
